import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { Store } from '@ngrx/store';

import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { AlertComponent, DisplayInputComponent } from '@components';
import { Payment, Transaction } from '@models';
import {
  fetchCurrentPaymentById,
  selectCurrentPayment,
  selectPaymentsFetchedAt,
} from '@state';
import { PaymentUtils } from '@utils';

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    DisplayInputComponent,
    AlertComponent,
    MatTableModule,
    MatIconModule,
  ],
  templateUrl: './payment.page.html',
  styleUrl: './payment.page.scss',
})
export class PaymentPage implements OnInit {
  public dataSource = new MatTableDataSource<Transaction>();
  public $payment = this.store.select(selectCurrentPayment);
  public $paymentsFetchedAt = this.store.select(selectPaymentsFetchedAt);

  public loading: boolean = false;
  public error: string | null = null;

  public columns: string[] = ['id', 'statementId', 'amount', 'status'];

  constructor(private store: Store, private router: Router) {}

  public ngOnInit(): void {
    this.store.dispatch(fetchCurrentPaymentById());
    this.$payment.subscribe((payment) => {
      if (payment?.transactions) this.dataSource.data = payment.transactions;
    });
  }

  public isPaid(payment: Payment): boolean {
    return PaymentUtils.isPaid(payment.status);
  }

  public getStatusText(payment: Payment): string {
    return PaymentUtils.getStatusText(payment.status);
  }

  public navToTransactionDetails(transactionId: any): void {
    this.router.navigate(['/transactions', transactionId]);
  }
}
